module.exports = __webpack_public_path__ + "media/images/global/projects/students-to-world-3be7fe16e8a3240aca7c16079065f890.png";